import { travelerFromFirestore } from '@parallel-fluidics/shared/models/travelers';
import {
  collection,
  getFirestore,
  where,
} from 'firebase/firestore';
import useCustomInfiniteQuery from 'hooks/use-customInfiniteQuery';
import { useMemo } from 'react';

const PAGE_SIZE = 20;

export default function useTravelersByPPartQuery(project, pPart, shipped) {
  const queryParams = useMemo(() => {
    if (!project || !pPart) return null;
    return [
      collection(getFirestore(), 'travelers'),
      where('project', '==', project),
      where('pPart', '==', pPart),
      where('shipped', '==', shipped),
    ];
  }, [project, pPart, shipped]);

  return useCustomInfiniteQuery({
    queryKey: `travelers_${project}_${pPart}_shipped_${shipped}`,
    queryParams: queryParams ?? [],
    pageSize: queryParams ? PAGE_SIZE : 0,
    staleTime: 2 * 60 * 1000,
    transformData: travelerFromFirestore,
  });
}
